<template>
  <div>
    <div class="row">
      <div class="col-12 table-container ">
        <Table
          :headers="headers"
          :cols="cols"
          :data="contacts"
          :checkbox="false"
          :notselect="true"
          :model="contacts"
        >
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Table from "@/components/Common/Table.vue";

export default {
  data() {
    return {
      cols: [
        [
          {
            value: "photo_url",
            type: "image"
          }
        ],
        [
          {
            value: "name",
            link: "linkedin_url",
            type: "link",
            class: "cursor-pointer",
            icons: [
              {
                icon_if: "linkedin_url",
                icon_true: "icon-linkedin text-primary"
              }
            ],
            tooltip: "name"
          }
        ],
        [
          {
            value: "title",
            tooltip: "title"
          }
        ],
        [
          {
            value: "organization",
            value2: "name",
            type: "link",
            link: "website"
          }
        ],
        [
          {
            value: "organization",
            value2: "industry",
            type: "ContactPreview",
            format: 1
          }
        ],
        [
          {
            value: "organization",
            value2: "specialties",
            type: "ContactPreview",
            format: 2
          }
        ],
        [
          {
            value: "organization",
            value2: "description",
            type: "ContactPreview",
            format: 2
          }
        ],
        [
          {
            value: "city_country"
          }
        ]
      ],
      headers: [
        {
          label: this.$t('lang.column.picture') ,
          percentage: "6%",
          class: "overflowhide",
          size: "30px"
        },
        {
          label: this.$t("lang.label.name"),
          percentage: "20%",
          class: "overflowhide",
          size: "150px"
        },
        {
          label: this.$t("lang.column.jobtitle"),
          percentage: "20%",
          class: "overflowhide",
          size: "140px"
        },
        {
          label: this.$t("lang.column.company"),
          percentage: "25%",
          class: "overflowhide",
          size: "150px"
        },
        {
          label:  this.$t("lang.column.industry"),
          percentage: "25%",
          class: "overflowhide",
          size: "140px"
        },
        {
          label:  this.$t("lang.search.specialties"),
          percentage: "25%",
          class: "overflowhide",
          size: "140px"
        },
        {
          label:  this.$t("lang.column.description"),
          percentage: "25%",
          class: "overflowhide",
          size: "140px"
        },
        {
          label:  this.$t("lang.column.contact_localization"),
          percentage: "25%",
          class: "overflowhide",
          size: "140px"
        }
      ]
    };
  },
  components: {
    Table
  },
  props: {
    contacts: {}
  },
mounted(){
  console.log(this.contacts);
}
};
</script>

<style scoped>
.table-container {
  overflow-x: auto; /* Habilitar el desplazamiento horizontal */
  white-space: nowrap; /* Evitar el ajuste de línea de las celdas */
}
table {
  border-spacing: 1em 0.5em;
  padding: 0 2em 1em 0;
}
table td {
  padding: 0 4em 1em 0;
  left: 150px;
}
.bold-text {
  color: #2f34e6;
  font-weight: bold;
}
</style>
